// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Cache key for the i18n files: assets are copied unhashed, so the loader
  // appends this so a released build fetches fresh translations. Also sent as
  // X-App-Version by interceptor.service.ts, which the API compares against
  // required-frontend-version.json — keep it a valid semver.
  appVersion: '4.3.0',
  versionDate: '2026-09-06'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
